import { Autocomplete, TextField } from "@mui/material";
import { FunctionComponent, useEffect } from "react";
import { Controller, useFormContext, Path } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { BLANK_OPTION, IFormValues } from "../../types";

interface FormControllerProps {
    options: {key: string, value: string}[],
    label: string,
    formName: Path<IFormValues>,
    showSelect: boolean,
    translationLabel?: string,
    sendValue?: boolean,
    disabled?: boolean,
    error?: boolean,
    helperText?: string | null,
    isMandatory?: boolean,
    idField?: string,
    getOptionLabel?: (opt: any) => string,
    handleAdditionalBehaviourOnChange?: (value: any) => void
}

const FormController: FunctionComponent<FormControllerProps> = ({
    options,
    label,
    formName,
    showSelect,
    translationLabel,
    sendValue = false,
    disabled = false,
    error = false,
    helperText = null,
    isMandatory = false,
    idField,
    getOptionLabel,
    handleAdditionalBehaviourOnChange
}) => {

    const { t } = useTranslation('customerbase');
    const formContext = useFormContext<IFormValues>();

    const findOptionByKey = (field: any) => options.find((c) => c.key == field.value)
    const findOptionByValue = (field: any) => options.find((c) => c.value == field.value)

    return (
        showSelect ? 
            <Controller 
                control={formContext.control}
                name={formName}
                render={({field, fieldState}) => (
                    <Autocomplete
                        {...field}
                        openOnFocus
                        autoHighlight
                        autoSelect
                        fullWidth
                        disabled={disabled}
                        id={!!idField ? idField : label}
                        options={isMandatory ? options : [BLANK_OPTION, ...options]}
                        renderInput={(params: any) => (
                            <TextField
                                {...params}
                                fullWidth
                                label={t(label)}
                                required={isMandatory}
                                error={error ? error : Boolean(fieldState.error)}
                                helperText={helperText ?? fieldState.error?.message}
                            />
                        )}
                        value={field.value ? (sendValue ? options.find((c) => c.value == field.value) || null : options.find((c) => c.key == field.value)) || null : null}
                        getOptionLabel={getOptionLabel || ((option: any) => !!translationLabel && !!option?.key ? t(`${translationLabel}.${option?.key}`): option?.key)}
                        onChange={(_event, value) => {
                            field.onChange(value);
                            
                            if(sendValue)
                                formContext.setValue(formName, value?.value || "");
                            else
                                formContext.setValue(formName, value?.key || ""); 

                            handleAdditionalBehaviourOnChange?.(value);
                        }}
                    />
                )}
            />
            :
            <Controller 
                control={formContext.control}
                name={formName}
                render={({field}) => (
                    <TextField
                        {...field}
                        fullWidth
                        disabled={disabled}
                        InputProps={{
                            readOnly: true
                        }}
                        label={t(label)}
                        required={isMandatory}
                        value={field.value ? 
                                (sendValue ? 
                                    (!!translationLabel && !!findOptionByValue(field)?.key ? t(`${translationLabel}.${findOptionByValue(field)?.key}`) || "--" : (getOptionLabel ? getOptionLabel(findOptionByValue(field)) : findOptionByValue(field)?.key) || "--")
                                    : 
                                    (!!translationLabel && !!findOptionByKey(field)?.key ? t(`${translationLabel}.${findOptionByKey(field)?.key}`) || "--" : (getOptionLabel ? getOptionLabel(findOptionByKey(field)) : findOptionByKey(field)?.key) || "--"))
                                : "--"
                        }
                    />
                )}
            />
        
    );
}

export default FormController;